<template>
  <!-- 活动管理 -->
  <div style="background-color: #fff;margin: 24px;padding: 24px;">
    <div class="activityManage">
      <div class="topbox">
        <img
          class="pointer"
          @click="handleBack()"
          src="@/assets/thdImg/pages/back.svg"
          alt=""
        />
        <span>{{ actQuery.isEdit ? "编辑活动" : "创建活动" }}</span>
      </div>
    </div>
    <div class="stepBox">
      <el-steps class="bz" :space="300" :active="1">
        <el-step title="设置规则"></el-step>
        <el-step title="完成发布"></el-step>
      </el-steps>
    </div>
    <div class="codeBox">
      <div class="codeBox_rq">
        <qrcode-vue
          class="qrcodeBox"
          id="qrcode"
          ref="qrcode"
          :size="qrcodeVue.size"
          :value="url"
          :logo="qrcodeVue.logo"
          :bgColor="qrcodeVue.bgColor"
          :fgColor="qrcodeVue.fgColor"
        ></qrcode-vue>
        <div class="codeBox_right">
          <div class="codeBox_tip">
            <img
              src="../../../assets/thdImg/throw/succu.svg"
              alt=""
              srcset=""
            />
            <div class="codeBox_right_zg">
              <span>活动设置完成！</span>
              <div>您还可以通过以下方式完成推广</div>
            </div>
          </div>
          <!-- <el-button
            style="border: 1px solid;margin-left: -144px;margin-top: 40px;"
            type="primary"
            @click="handleSrcImg()"
            >下载二维码</el-button
          > -->
        </div>
      </div>
      <p class="codeBox_title">京东APP扫码查看活动</p>
      <!-- <div class="codeBox_input">活动链接：</div> -->
      <div
        class="codeBox_input"
        v-for="(item, index) in lockUrlArr"
        style="margin-top:10px"
      >
        <span style="display:inline-block;width:75px;text-align:right">{{
          item.label
        }}</span>
        <el-input
          readonly
          v-model="item.value"
          style="margin: 0 20px; width: 220px"
        ></el-input
        ><el-button
          type="primary"
          v-clipboard:copy="item.value"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
          >复制</el-button
        ><el-button type="primary" plain @click="handleSrcImg(index)"
          >下载</el-button
        >
        <qrcode-vue
          style="display: none;"
          :id="`qrcode${index + 1}`"
          :ref="`qrcode${index + 1}`"
          :size="250"
          :value="item.value"
          :logo="qrcodeVue.logo"
          :bgColor="qrcodeVue.bgColor"
          :fgColor="qrcodeVue.fgColor"
        ></qrcode-vue>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";

import qrcodeVue from "qrcode-vue";
import { activityDetail } from "@/api/paradiseAndTaskCommonController.js";
export default {
  props: {},
  components: {
    qrcodeVue,
  },
  data() {
    return {
      lockUrlArr: [
        { label: "商品详情", value: "" },
        { label: "店铺首页", value: "" },
        { label: "会员二级页", value: "" },
        { label: "推广页", value: "" },
        { label: "其他", value: "" },
      ],
      qrcodeVue: {
        size: 250,
        bgColor: "#fff",
        fgColor: "#000",
        value: "https://www.baidu.com/", //二维码地址
        logo: require("@/assets/thdImg/common/jd_logo.svg"), //logo图片
      },
      url: "",
      actQuery: {},
      actInfo: {},
    };
  },

  mounted() {
    this.actQuery = this.$route.query;
    this.init();
  },

  methods: {
    handleBack() {
      this.$router.push({
        name: "pointLockAuth",
      });
    },
    async init() {
      const { data: item } = await activityDetail({
        id: this.actQuery.id,
        activityType: this.actQuery.activityType,
      });
      console.log(item, 11111);
      this.actInfo = item;
      // 二维码进小程序
      let xcxUrl = this.$commonUrl(); // 正式
      let options = {
        activityId: item.id,
        venderId: item.venderId,
        activityType: this.actQuery.activityType,
        id: item.id,
        index: this.actQuery.activityType == 12 ? 2 : 1,
      };
      let params35 = (id) => {
        return `activityId%3D${options.activityId}%26venderId%3D${options.venderId}%26activityType%3D${options.activityType}%26channelCode%3D${id}`;
      };
      this.url =
        xcxUrl +
        "pages/interactTask/lockAuth/lockAuth.html%3f" +
        params35(1001);
      this.lockUrlArr[0].value =
        xcxUrl +
        "pages/interactTask/lockAuth/lockAuth.html%3f" +
        params35(1001);
      this.lockUrlArr[1].value =
        xcxUrl +
        "pages/interactTask/lockAuth/lockAuth.html%3f" +
        params35(1002);
      this.lockUrlArr[2].value =
        xcxUrl +
        "pages/interactTask/lockAuth/lockAuth.html%3f" +
        params35(1003);
      this.lockUrlArr[3].value =
        xcxUrl +
        "pages/interactTask/lockAuth/lockAuth.html%3f" +
        params35(1004);
      this.lockUrlArr[4].value =
        xcxUrl +
        "pages/interactTask/lockAuth/lockAuth.html%3f" +
        params35(1005);
    },
    onCopy() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.error("复制失败");
    },
    handleSrcImg(index) {
      // 获取要下载的图片
      let img = document.querySelector(`#qrcode${index + 1} img`);
      // 获取图片地址
      let url = img.src;
      // 创建一个a节点插入的document
      let a = document.createElement("a");
      // 模拟鼠标click点击事件
      let event = new MouseEvent("click");
      // 设置a节点的download属性值
      a.download = "huodongyulan";
      // 将图片的src赋值给a节点的href
      a.href = url;
      // 触发鼠标点击事件
      a.dispatchEvent(event);
    },
  },
};
</script>

<style lang="scss" scoped>
.topbox {
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  color: #000;
}
.activityManage {
  box-sizing: border-box;
  // padding: 20px 28px 30px;
  box-sizing: border-box;
  // padding: 24px;
  // margin: 24px;
  background: #fff;
}
.codeBox {
  text-align: center;
  margin: 0 auto;
  width: 555px;
  margin-bottom: 20px;
  &_rq {
    width: 100%;
    // height: 260px;
    // border: 1px solid #000;
    margin: 0 auto;
    display: flex;
    .qrcodeBox {
      box-shadow: 0px 4px 20px 0px rgba(18, 10, 60, 0.15);
      border-radius: 12px 12px 12px 12px;
      border: 1px solid #ffffff;
      width: 270px;
      height: 270px;
      padding: 8px;

      /deep/img {
        width: 250px !important;
        height: 250px !important;
      }
    }
  }
  &_right {
    margin-left: 24px;
    &_zg {
      text-align: left;
      margin-left: 11px;
      span {
        padding-top: 5px;
        display: block;
        font-size: 16px;
      }
      div {
        margin-top: 9px;
        color: #666666;
      }
    }
  }
  &_tip {
    display: flex;
    padding-top: 70px;
  }
  &_title {
    font-size: 16px;
    // font-weight: bold;
    margin: 20px 0;
    text-align: left;
    color: #666;
    padding-left: 53px;
  }
  &_input {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
